export default class UserID{
  constructor({ID:id,Type:type}){
      this.ID = id;
      this.Type = type;
  }
  toString(){
      return JSON.stringify(this);
  }
}